import React, { FunctionComponent } from "react";

const Content: FunctionComponent = ({ children }) => <div className="content">{children}</div>;

export default Content;
